export default "__VITE_ASSET__D9iseG_u__"